const NS = 'NotepadCardsWidget';                                                                                                                                       
import { handleTruncate } from '../../../../global/js/wlc/truncate';
export class NotepadCardsWidget {
    constructor(element) {
        this.element = element;
        this.$element = $(element);
        this.$notes = $(`.notepadCardsWidget-container`);
        this.$contentDescription = this.$element.find(`.notepadItem-content-description`);
        $.each(this.$contentDescription, function(i, val) {
            handleTruncate($(val), 220);
        });
        this.deleteNote();
    }

    deleteNote(){
        this.$deleteBtn = this.$element.find(`.notepadItem-col--stats .deleteNote`);
        $.each(this.$deleteBtn, function(i, val) {
            $(val).click(function() {
                if(confirm("Press OK to confirm delete this note")){
                var json_text = $(val).data('topicid');
                var notesData = $(`.notepadCardsWidget-container`).data('deleteApi');
                let request = new Request(notesData, {
                    method: 'POST',
                    body: json_text,
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
            
                // submit form data using fetch api
                fetch(request)
                .then((response) => {
                    if(response.status === 200) {
                        location.reload();
                    }
                    else {
                        //console.log("Note can't delete.");
                    }
                })
                .catch((error) => {
                    //console.log("Delete Error!");
                });
            }
            });
        });
    }
}